import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_HXfIX3OeH5uy: {
	id: 'prd_HXfIX2DEV23OeH5uy'
	ident: 'prd_HXfIX3OeH5uy'
	sku: 'simple_premium_1w_5_19_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 1
			iteration_count: 1
			price_id: 'prc_hvCgn2DEV2orpVFby'
			amount: 22
			amount_usd: 5.19
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 5.19
			discount: 16.81
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_VkyW82DEV2JoEsKHs'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_HXfIX3OeH5uy, SubscriptionProduct>
const prd_HXfIX3OeH5uy = { ident: 'prd_HXfIX3OeH5uy' } as typeof _prd_HXfIX3OeH5uy

export default prd_HXfIX3OeH5uy
